
export const priceUnits = [
  { value: 'rial', label: 'ریال' },
  { value: 'dollar', label: 'دلار' },
  { value: 'rupee', label: 'روپیه' },
  { value: 'afghanis', label: 'افغانی' },
]
